const MONITORING_TOUR_START_REQUEST_EVENT = 'monitoring-tour-start-request';

let pendingRequest = false;

export const requestMonitoringTourStart = (): void => {
  pendingRequest = true;
  window.dispatchEvent(new Event(MONITORING_TOUR_START_REQUEST_EVENT));
};

export const hasMonitoringTourStartRequest = (): boolean => pendingRequest;

export const consumeMonitoringTourStartRequest = (): boolean => {
  if (!pendingRequest) return false;

  pendingRequest = false;

  return true;
};

export const subscribeMonitoringTourStartRequest = (
  listener: () => void
): (() => void) => {
  window.addEventListener(MONITORING_TOUR_START_REQUEST_EVENT, listener);

  return () =>
    window.removeEventListener(MONITORING_TOUR_START_REQUEST_EVENT, listener);
};
